<template>
	<div v-if="markup" class="ad" :class="'ad--' + size">
		<span v-if="isOn(showLabel)" class="ad__label">{{ label }}</span>
		<div class="ad__code" v-html="markup"></div>
	</div>
</template>

<script>
/**
 * AdSlotBlock.vue — public variant
 * ────────────────────────────────
 * An ad position. With the MediaOS source it renders `<mos-creative …>` for
 * the chosen product / ad units (served by the MediaOS ad server, GAM
 * passback included); with the external source it renders the pasted tag.
 * Renders NOTHING when the slot is not configured so an unsold position
 * leaves no gap. The editor variant shows a labelled placeholder instead.
 */
import { buildAdSlotMarkup } from './adSlotShared.js';

export default {
	name: 'AdSlotBlock',

	props: {
		provider: { type: String, default: 'mediaos' },
		adAttrs: { type: [Object, String, Array], default: function () { return {}; } },
		embedCode: { type: String, default: '' },
		size: { type: String, default: 'leaderboard' },
		label: { type: String, default: 'Advertisement' },
		showLabel: { type: [Boolean, String], default: true }
	},

	computed: {
		markup: function () { return buildAdSlotMarkup(this.provider, this.adAttrs, this.embedCode); }
	},

	methods: {
		isOn: function (v) { return v === true || v === 'true' || v === 1 || v === '1'; }
	}
};
</script>

<style scoped>
.ad { display: inline-block; max-width: 100%; text-align: center; }
.ad__label { display: block; font-size: .7em; letter-spacing: .08em; text-transform: uppercase; opacity: .55; margin-bottom: 4px; }
.ad__code { display: inline-block; max-width: 100%; }
.ad--leaderboard .ad__code { width: 728px; min-height: 90px; }
.ad--rectangle .ad__code { width: 300px; min-height: 250px; }
.ad--halfPage .ad__code { width: 300px; min-height: 600px; }
.ad--mobile .ad__code { width: 320px; min-height: 50px; }
.ad--auto .ad__code { width: auto; }
</style>
